









































































































































import Vue from 'vue'
import {
  Component, Prop, Emit, Watch,
} from 'vue-property-decorator';
import { VbTooltipSlot } from '@/shared/slots/tooltip-slot.component.vue';
import { VbSnackbarService } from '@/shared/snackbar/snackbar.service';
import { VbDirectives } from '@/shared/directive/vb-directives';
import ModalComponent from '@/shared/modal/modal.component.vue'
import LabelSlot from '@/shared/slots/label-slot.component.vue';
import DateFormat from '@/shared/utils/date-format';
import FilterUtils from '@/shared/utils/filters';
import { VMoney } from 'v-money';
import ModalWarning from '@/shared/modal/modal-warning.component.vue';
import CancelContractRequest from '@/domain/contract/request/cancel-contract.request'
import Rules from '@/shared/rules/rules';
import ModalOptions from '@/shared/modal/modal-options.entity';
import Contract from '@/domain/contract/entity/contract.entity';
import CancelItemRuleRequest from '@/domain/contract/request/cancel-item-rule.request';
import ContractService from '@/domain/contract/service/contract.service';
import BillingStrategys from './billing-strategys.json';

@Component({
  components: {
    ModalComponent,
    VbTooltipSlot,
    LabelSlot,
    ModalWarning,
  },
  directives: {
    money: VMoney,
  },
  filters: {
    formatDate(value: string) {
      return DateFormat.timestampToLocal(value)
    },
    toCurrency: VbDirectives.toCurrency,
    monthYear(value: string): string {
      const date: string = DateFormat.localDateToLocal(value);
      return DateFormat.fullMonthAndYear(date);
    },
  },
})
export default class EditObservationModal extends Vue {
  @Prop({ required: true })
  show!: boolean;

  @Prop({ required: true, default: '' })
  businessUnitId!: string;

  @Prop({
    required: true,
  })
  contract!: Contract;

  private ref: any = this.$refs;

  request: CancelContractRequest = CancelContractRequest.of({});

  validationRules: Rules = new Rules();

  billingStrategys = BillingStrategys;

  locale = 'pt-BR';

  percentKey = 0;

  dateKey = 0;

  warningModal: boolean = false;

  competence: string = '';

  pickerMenu: boolean = false;

  rulesLoaded: boolean = false;

  warningMessage = 'Deseja realmente prosseguir? Ao clicar no botão Sim, o contrato será imediatamente cancelado e gerada uma nova fatura conforme as configurações selecionadas'

  percent: object = {
    decimal: ',',
    thousands: '.',
    precision: 2,
    prefix: '% ',
    masked: false,
    max: 9999.99,
    min: 0.01,
  };

  @Watch('show')
  onShowChange(value: boolean) {
    if (value && !this.rulesLoaded && this.contract?.id) {
      this.loadRules();
    }
  }

  loadRules() {
    ContractService.getCancelItemRules(this.contract.id)
      .then((rules: CancelItemRuleRequest[]) => {
        this.request.rules = rules;
        this.request.contractId = this.contract.id;
        this.rulesLoaded = true;
      })
      .catch(VbSnackbarService.handleHttpError);
  }

  rerenderTextFields(): void {
    this.dateKey += 1;
    this.percentKey += 1;
  }

  closeWarningModal() {
    this.warningModal = false;
  }

  handleConfirm() {
    this.$emit('ok', this.request);
    this.closeWarningModal();
  }

  get options(): ModalOptions {
    return {
      title: 'Configurações de Cancelamento',
      titleAlign: 'center',
      showClose: false,
      showOk: true,
      labelOk: 'Salvar',
      okColor: 'bluePrimary',
      showCancel: true,
      labelCancel: 'Cancelar',
      width: 720,
      persistent: true,
    }
  }

  getFormattedValue(value: any): number {
    return typeof value === 'string' ? Number(FilterUtils.formatValue(value)) : value;
  }

  private ok() {
    if (this.ref.form.validate()) {
      this.warningModal = true;
    }
  }

  @Emit('cancel')
  private cancel(): void {}
}
